module.exports = __webpack_public_path__ + "img/logo.20f9b289.png";